import React from "react";
import HeroSection from "../containers/PointOFSale/HeroSection";
import Section_one from "../containers/PointOFSale/Section_one";
import Tecno from "../containers/PointOFSale/Tecno";
import Industry from "../containers/PointOFSale/Industries";
import OurWork from "../containers/PointOFSale/OurWork"
const PointOFSale = () => {
  return (
    <div>
      <HeroSection />
      <Section_one />
      <div className="bg-gradient-to-b from-[#e0f4f5] to-white">
        <Industry />
      </div>
      <Tecno />
      <div className="bg-gradient-to-b from-[#D3EEFF] to-white">

      <OurWork/>
      </div>
    </div>
  );
};

export default PointOFSale;
